@import 'styles/mixins';

.actions {
  display: flex;
  gap: 6px;
  justify-content: space-between;

  button {
    flex-grow: 1;
  }
}
